import styled from '@xstyled/styled-components';

export default styled.div`
  position: relative;
  display: flex;
  width: 100%;
  height: 100%;
  flex: 1;
  align-items: center;
  justify-content: center;
  color: white;
`;
